import styled from 'styled-components'

export const TableWrapper = styled.div`
  width: 100%;
  max-height: 70vh;
  overflow-x: auto;
  overflow-y: auto;
  border-radius: ${({ $compact }) => ($compact ? '6px' : '0.5rem')};
  box-shadow: ${({ $compact }) => ($compact ? 'none' : '0 0 4px rgba(0,0,0,0.1)')};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};

  &::-webkit-scrollbar {
    height: 4px;
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
  }
`

export const TableEl = styled.table`
  width: 100%;
  min-width: ${({ $compact }) => ($compact ? '760px' : '900px')};
  border-collapse: collapse;
  font-size: ${({ $compact }) => ($compact ? '11.5px' : '14px')};
`

export const TableHead = styled.thead`
  background: ${({ theme }) => theme.colors.borderDefault};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
  position: sticky;
  top: 0;
  z-index: 2;
`

export const TableHeader = styled.th`
  padding: ${({ $compact }) => ($compact ? '8px 10px' : '12px 16px')};
  text-align: ${(props) => props.align || 'left'};
  font-weight: 600;
  font-size: ${({ $compact }) => ($compact ? '0.625rem' : 'inherit')};
  letter-spacing: ${({ $compact }) => ($compact ? '0.03em' : 'normal')};
  text-transform: ${({ $compact }) => ($compact ? 'uppercase' : 'none')};
  color: ${({ theme, $compact }) =>
    $compact ? theme.colors.textMuted : 'inherit'};
  white-space: nowrap;
`

export const TableBody = styled.tbody``

export const TableRow = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSubtle || theme.colors.borderDefault};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  background-color: ${({ $danger, $selected, theme }) => {
    if ($selected) {
      return theme.name === 'dark'
        ? 'rgba(62, 207, 142, 0.14)'
        : 'rgba(62, 207, 142, 0.1)'
    }
    if ($danger) {
      return theme.name === 'dark'
        ? 'rgba(220, 38, 38, 0.08)'
        : 'rgba(220, 38, 38, 0.04)'
    }
    return 'transparent'
  }};

  &:hover {
    background-color: ${({ $danger, $selected, theme }) => {
      if ($selected) {
        return theme.name === 'dark'
          ? 'rgba(62, 207, 142, 0.18)'
          : 'rgba(62, 207, 142, 0.14)'
      }
      if ($danger) {
        return theme.name === 'dark'
          ? 'rgba(220, 38, 38, 0.12)'
          : 'rgba(220, 38, 38, 0.07)'
      }
      return theme.colors.borderDefault
    }};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.action.primary.bg};
    outline-offset: -2px;
  }
`

export const TableCell = styled.td`
  padding: ${({ $compact }) => ($compact ? '6px 10px' : '8px 18px')};
  text-align: ${(props) => props.align || 'left'};
  vertical-align: top;
`

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`
